const RETIRE_LEGACY = {
  name: "Retire",
  value: "retire",
  icon: "icons/dropdown/activate.svg",
};

const RETIRE_RANGE = { ...RETIRE_LEGACY, name: "Retire range" };

const STATIC_ROW_ACTIONS = {
  draft: [
    { name: "Delete", value: "delete-draft", icon: "icons/dropdown/delete.svg", destructive: true },
  ],
  active: [RETIRE_LEGACY],
  retired: [
    { name: "Reactivate", value: "reactivate", icon: "icons/dropdown/activate.svg" },
    { name: "Archive", value: "archive", icon: "icons/dropdown/archive.svg" },
  ],
  archived: [
    { name: "Unarchive", value: "unarchive", icon: "icons/dropdown/unarchive.svg" },
  ],
};

const NEW_VERSION = {
  name: "New version",
  value: "new-version",
  icon: "icons/dropdown/file-plus-02.svg",
};

/**
 * Overflow-menu items of a Pay Ranges list row (Rule 33 / ER-12162).
 * A Published range's menu depends on its pending Draft and Future version, and only when the
 * row carries the version history (idea-MDP-429); every other row keeps its status menu.
 * @param {{ status?: string, version_history?: boolean, pending_draft?: object|null,
 *   future_version?: { version_number: number }|null }} row
 * @returns {Array<{ name: string, value: string, icon: string, destructive?: boolean,
 *   disabled?: boolean, disabledReason?: string }>}
 */
export function payRangeRowMenuItems(row = {}) {
  const status = String(row.status || "").toLowerCase();
  if (status !== "active" || !row.version_history) {
    return STATIC_ROW_ACTIONS[status] ?? [];
  }
  if (row.pending_draft) {
    return [
      { name: "Edit draft", value: "edit-draft", icon: "icons/dropdown/edit-05.svg" },
      { name: "Publish draft", value: "publish-draft", icon: "icons/dropdown/send-01.svg" },
      {
        name: "Discard draft",
        value: "discard-draft",
        icon: "icons/dropdown/trash-01.svg",
        destructive: true,
      },
      RETIRE_RANGE,
    ];
  }
  if (row.future_version) {
    const next = `V${row.future_version.version_number}`;
    return [
      {
        ...NEW_VERSION,
        disabled: true,
        disabledReason: `Void next version ${next} first`,
      },
      {
        name: "Void next version",
        value: "void-next-version",
        icon: "icons/dropdown/slash-circle-01.svg",
      },
      RETIRE_RANGE,
    ];
  }
  return [NEW_VERSION, RETIRE_RANGE];
}
